import { CheckCircleTwoTone, CloseCircleFilled, CloseCircleTwoTone, MinusCircleOutlined } from '@ant-design/icons';

export const SuccessIcon = () => <CheckCircleTwoTone twoToneColor="#52c41a" />;
export const FailedIcon = () => <CloseCircleTwoTone twoToneColor="#c41a52" />;
export const FailedIconFilled = () => <CloseCircleFilled style={{ color: 'red', fontSize: '1.1rem' }} />;
export const ExcludedIcon = () => <MinusCircleOutlined twoToneColor="#d9d9d9" />;
